import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import InfoBox from 'components/Shared/InfoBox'
import Switch from 'components/Shared/Controls/Switch'
import {
  useCampaignMenu,
  useCampaignMenuDispatch,
} from 'components/Recommendations/Campaign/CampaignMenu/CampaignMenuContext'
import { actions } from 'components/Recommendations/Campaign/CampaignMenu/campaignStatusReducer'
import PortalModal from 'components/Shared/PortalModal'
import CampaignOptimizationModal from 'components/Recommendations/CampaignStatusModals/CampaignOptimizationModal'

export default function CampaignOptimisation({ event }) {
  const { t } = useTranslation()
  const { isCampaignOptimizationOn, isAdCampaignOptimizationOn } = useCampaignMenu()
  const statusDispatch = useCampaignMenuDispatch()

  const [isOptimizationModalOpen, setIsOptimizationModalOpen] = useState(false)
  const [isAdOptimizationModalOpen, setIsAdOptimizationModalOpen] = useState(false)

  return (
    <div className="d-flex gap-4 align-items-center flex-wrap" style={{ rowGap: '1rem', columnGap: '2rem' }}>
      <InfoBox
        content="Tips.Recommendations.campaignOptimisation"
      >
        <span>{t('Recommendations.summary.advancedSettings.campaignOptimisation.title')}</span>
      </InfoBox>

      <div className="d-flex flex-wrap gap-4">
        <div className="d-flex align-items-center">
          <p>{t('Recommendations.summary.advancedSettings.campaignOptimisation.forCampaign')}</p>

          <Switch
            classNames="p-0"
            checked={isCampaignOptimizationOn}
            onClick={() => {
              setIsOptimizationModalOpen(true)
            }}
          />
        </div>

        <div className="d-flex align-items-center">
          <p>{t('Recommendations.summary.advancedSettings.campaignOptimisation.forAds')}</p>

          <Switch
            classNames="p-0"
            checked={isAdCampaignOptimizationOn}
            onClick={() => {
              setIsAdOptimizationModalOpen(true)
            }}
          />
        </div>
      </div>

      <PortalModal
        isOpen={isOptimizationModalOpen}
        onClickOutside={() => setIsOptimizationModalOpen(false)}
      >
        <CampaignOptimizationModal
          status={isCampaignOptimizationOn ? 'deactivate' : 'activate'}
          translationKey="campaignOptimizationModal"
          onCancel={() => setIsOptimizationModalOpen(false)}
          onConfirm={() => {
            setIsOptimizationModalOpen(false)
            statusDispatch({ type: actions.toggleCampaignOptimizationAsync, payload: { event } })
          }}
        />
      </PortalModal>

      <PortalModal
        isOpen={isAdOptimizationModalOpen}
        onClickOutside={() => setIsAdOptimizationModalOpen(false)}
      >
        <CampaignOptimizationModal
          status={isAdCampaignOptimizationOn ? 'deactivate' : 'activate'}
          translationKey="adCampaignOptimizationModal"
          onCancel={() => setIsAdOptimizationModalOpen(false)}
          onConfirm={() => {
            setIsAdOptimizationModalOpen(false)
            statusDispatch({ type: actions.toggleAdCampaignOptimizationAsync, payload: { event } })
          }}
        />
      </PortalModal>
    </div>
  )
}

CampaignOptimisation.propTypes = {
  event: PropTypes.object.isRequired,
}